import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { useI18n } from "@/i18n/I18nContext";

export default function PaymentCancel() {
  const { t } = useI18n();
  return (
    <>
      <Nav />
      <div className="pt-40 pb-32 max-w-[900px] mx-auto px-6 text-center">
        <div className="overline">{t("cancel.tag")}</div>
        <h1 className="font-serif text-6xl md:text-7xl font-light mt-6">{t("cancel.heading")}</h1>
        <p className="mt-8 text-ionian/70">{t("cancel.body")}</p>
        <div className="mt-12 flex gap-4 justify-center">
          <Link to="/booking" data-testid="cancel-retry" className="btn-brass px-8 py-3 rounded-full text-sm uppercase tracking-widest">{t("cancel.retry")}</Link>
          <Link to="/" className="btn-ionian px-8 py-3 rounded-full text-sm uppercase tracking-widest">{t("cancel.home")}</Link>
        </div>
      </div>
      <Footer />
    </>
  );
}
